import { render, staticRenderFns } from "./SubjectsPage.vue?vue&type=template&id=526c36c8&scoped=true&"
import script from "./SubjectsPage.vue?vue&type=script&lang=ts&"
export * from "./SubjectsPage.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectsPage.vue?vue&type=style&index=0&id=526c36c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c36c8",
  null
  
)

export default component.exports